import { Airline } from "../types/Airline";

export const mapAirlinesToDisplay = (airlines: Airline[]): string =>
    airlines.map((airline: Airline) => airline.name).join(", ");
